export const GET_RATES_REQUEST = "GET_RATES_REQUEST"
export const GET_RATES_REQUEST_SUCCESS = "GET_RATES_REQUEST_SUCCESS"

export const CREATE_RATES_REQUEST = "CREATE_RATES_REQUEST"
